// Sentencing status. Reads matter.workspace.sentencing if present, else
// shows next court date(s) from matter.workspace.courtDates.

import type { CourtDateShape } from "../workspace-shapes";

interface SentencingShape {
  scheduled?: string;
  outcome?: string;
  guidelinesRange?: string;
  imposed?: string;
}

interface Props {
  sentencing: SentencingShape | undefined;
  courtDates: CourtDateShape[] | undefined;
}

export function SentencingCard({ sentencing, courtDates }: Props) {
  return (
    <div className="cc-card">
      <div className="cc-card-head">
        <div className="cc-card-title">Sentencing & court dates</div>
        <div className="cc-card-sub">
          {sentencing?.outcome
            ? "· " + sentencing.outcome
            : courtDates && courtDates.length > 0
              ? `· next: ${courtDates[0].event}`
              : "· no dates set"}
        </div>
      </div>
      <div style={{ padding: "14px 18px 16px" }}>
        {sentencing && (
          <div
            style={{
              padding: "10px 12px",
              borderRadius: 6,
              background: "var(--bg)",
              border: "1px solid var(--line)",
              marginBottom: 12,
            }}
          >
            {sentencing.guidelinesRange && (
              <div
                style={{
                  fontSize: 9.5,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  color: "var(--muted)",
                }}
              >
                Guidelines
              </div>
            )}
            {sentencing.guidelinesRange && (
              <div style={{ fontSize: 13, fontWeight: 600 }}>{sentencing.guidelinesRange}</div>
            )}
            {sentencing.imposed && (
              <div
                style={{
                  marginTop: 6,
                  fontSize: 12,
                  color: "var(--ink-2)",
                }}
              >
                <b>Imposed:</b> {sentencing.imposed}
              </div>
            )}
          </div>
        )}
        {!courtDates || courtDates.length === 0 ? (
          <div style={{ fontSize: 12.5, color: "var(--muted)" }}>No court dates scheduled.</div>
        ) : (
          <div>
            <div
              style={{
                fontSize: 9.5,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: "var(--muted)",
                marginBottom: 6,
              }}
            >
              Upcoming dates
            </div>
            {courtDates.map((d, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "6px 0",
                  borderBottom: i === courtDates.length - 1 ? "none" : "1px solid var(--line-2)",
                }}
              >
                <span
                  style={{
                    fontVariantNumeric: "tabular-nums",
                    fontSize: 11.5,
                    fontWeight: 600,
                    color: "var(--ink)",
                    minWidth: 130,
                  }}
                >
                  {d.date}
                </span>
                <span style={{ fontSize: 12, color: "var(--ink-2)" }}>{d.event}</span>
                {d.venue && (
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: 10.5,
                      color: "var(--muted)",
                    }}
                  >
                    {d.venue}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
